import styled from 'styled-components';
import videoBgSrc from '../../assets/video-bg.png';

export const AboutUsWrapper = styled.div`
  margin-top: 90px;
  @media (max-width: 800px) {
    margin-top: 70px;
  }
`;

export const VideoWrapper = styled.div`
  padding: 80px 0;
  background-image: url(${videoBgSrc});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;